function getTotalEarnings(cpEarnings, revshareEarnings) {
    return cpEarnings + (revshareEarnings > 0 ? revshareEarnings : 0);
}

/**
 * Per-advertiser / per-aggregate publisher total. Prefers the
 * `customerTotalRevenue` field the backend now computes per-SBL (so chargeback
 * days on one deal don't eat positive revshare on another). Falls back to the
 * raw cp + max(rs, 0) formula for per-SBL rows that don't carry the field —
 * those are already at SBL granularity so the formula is correct for them.
 *
 * @param {object} metrics
 * @returns {number}
 */
function getMetricsCustomerTotal(metrics) {
    if (!metrics) return 0;
    if (typeof metrics.customerTotalRevenue === 'number') return metrics.customerTotalRevenue;
    return getTotalEarnings(metrics.customerCPRevenue || 0, metrics.customerRevshareRevenue || 0);
}

/**
 * Same logic as getMetricsCustomerTotal but for "our" cut of the revenue.
 *
 * @param {object} metrics
 * @returns {number}
 */
function getMetricsOurTotal(metrics) {
    if (!metrics) return 0;
    if (typeof metrics.ourTotalRevenue === 'number') return metrics.ourTotalRevenue;
    return getTotalEarnings(metrics.ourCPRevenue || 0, metrics.ourRevshareRevenue || 0);
}

module.exports = {
    getTotalEarnings,
    getMetricsCustomerTotal,
    getMetricsOurTotal,
};
